import React, { useState, useEffect } from "react";
import sortBy from "lodash/sortBy";
import { Spinner, Row, Space } from "@masterteam/mt-design-react";

import Breadcrumb from "../Breadcrumb";
import InitiativeTitle from "./InitiativeTitle";
import ListsContainer from "./ListsContainer";

import api from "../../providers/api";
import { addToast } from "../../helpers";

import "./style.scss";
import InfoCards from "./InfoCards";

function InitiativesDetails({ match }) {
  const parts = match?.url?.split("/");
  const [initiative, setInitiative] = useState({});
  const [objective, setObjective] = useState({});

  const [dataLoading, setDataLoading] = useState(true);
  const [initiativeStatus, setInitiativeStatus] = useState([]);
  const [projectsStatus, setProjectsStatus] = useState([]);

  async function getData() {
    setDataLoading(true);
    try {
      const [
        initiativeStatusRes,
        initiativesRes,
        objectiveRes,
        resProjectsStatuses
      ] = await Promise.all([
        api.initiatives.initiativeStatuses(),
        api.initiatives.getInitiativeDetails(match.params.id),
        api.strategyMap.getObjectiveByID(parts[3] || 0),
        api.handshake.getProjectStatuses(),
        ,
      ]);
      setInitiativeStatus(
        initiativeStatusRes?.Data
          ? sortBy(initiativeStatusRes?.Data, "Order")
          : []
      );
      setInitiative(initiativesRes.Data);
      setObjective(objectiveRes.Data);
      setProjectsStatus(
        resProjectsStatuses.Data
          ? sortBy(resProjectsStatuses.Data, "Order")
          : []
      );
    } catch (err) {
      addToast.error(err.message, {
        toastId: "get-users-error"
      });
    } finally {
      setDataLoading(false);
    }
  }

  useEffect(() => {
    getData();
  }, [match.params.id]);

  let breadcrumbData = [
    {
      ...objective?.Pillar?.Strategy,
      path: `/splus/strategy-map/${objective?.Pillar?.Strategy?.ID}`
    },
    objective?.Pillar,
    { ...objective, path: `/splus/objective-details/${objective?.ID}` },
    initiative
  ];
  if (objective?.ParentID)
    breadcrumbData.splice(2, 0, {
      ...objective.ObjectiveParent,
      path: `/splus/objective-details/${objective.ObjectiveParent?.ID}`
    });

  return (
    <Space direction="vertical" size="large" className="initiatives__container">
      {dataLoading ? (
        <div className="loader-container">
          <Spinner size="large" />
        </div>
      ) : (
        <div>
          <Row className="objective-container__header">
            <Breadcrumb data={breadcrumbData} fontSize="var(--font-large)" />
          </Row>

          <Space
            direction="vertical"
            size="large"
            className="objective-container__content"
          >
            <InitiativeTitle
              initiative={initiative}
              parentKey={"Pillar"}
              statuses={initiativeStatus}
            />
            <InfoCards
              initiative={initiative}
              projectStatuses={projectsStatus}
              initiativeStatus={initiativeStatus}
            />

            <ListsContainer
              projectStatuses={projectsStatus}
              initiative={initiative}
            />
          </Space>
        </div>
      )}
    </Space>
  );
}

export default InitiativesDetails;
